import * as getters from "../../baseQuestion/multiField/store/getters";
import * as mutations from "../../baseQuestion/multiField/store/mutations";
import * as actions from "../../baseQuestion/multiField/store/actions";
import { state as base_state } from "../../baseQuestion/multiField/store/state";

function state() {
	return base_state();
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
